module.exports = __webpack_public_path__ + "static/media/Photo20.08a1fddc.jpg";